import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Parking: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_591)">
                <IconPath
                    d="M10.5 12.75H12.75C13.3467 12.75 13.919 12.5129 14.341 12.091C14.7629 11.669 15 11.0967 15 10.5C15 9.90326 14.7629 9.33097 14.341 8.90901C13.919 8.48705 13.3467 8.25 12.75 8.25H10.5V12.75ZM10.5 12.75V17.25M0.75 12C0.75 14.9837 1.93526 17.8452 4.04505 19.955C6.15483 22.0647 9.01631 23.25 12 23.25C14.9837 23.25 17.8452 22.0647 19.955 19.955C22.0647 17.8452 23.25 14.9837 23.25 12C23.25 9.01631 22.0647 6.15483 19.955 4.04505C17.8452 1.93526 14.9837 0.75 12 0.75C9.01631 0.75 6.15483 1.93526 4.04505 4.04505C1.93526 6.15483 0.75 9.01631 0.75 12Z"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_591">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
